<template>
    <div class="bounceDetail">
        <div class="breadcrumb">APP首页弹框管理 > 查看详情
            <el-button class="right_f" type="primary" @click="goback">返回</el-button>
        </div>
        <div class="detail">
            <div class="panel">
                <span class="title">弹框名称：</span>{{bounce.name}}
            </div>
            <div class="panel">
                <span class="title">弹框类型：</span>{{bounce.bounceType}}
            </div>
            <div class="panel">
                <span class="title imgSpan">弹框图片：</span>&nbsp;
                <img :src="bounce.irregularImgUrl" v-if="bounce.irregularImgUrl">
                <img :src="bounce.imgUrl" style="margin-left:5px;">
            </div>
            <div class="panel">
                <span class="title">弹框主标题：</span>{{bounce.mainTitle}}
            </div>
            <div class="panel">
                <span class="title">弹框副标题：</span>{{bounce.subTitle}}
            </div>
            <div class="panel">
                <span class="title">按钮文案：</span>{{bounce.btnText}}
            </div>
            <div class="panel">
                <span class="title">弹出周期：</span>{{bounce.showStatus}}
            </div>
            <div style="height: 135px;margin-bottom:20px;" v-if="bounce.adExposingCodes">
                <span class="title">广告曝光代码：</span>
                <span class="contain">{{bounce.adExposingCodes}}</span>
            </div>
            <div class="panel">
                <span class="title">起止日期：</span>{{bounce.startTime}}&nbsp;至&nbsp;{{bounce.endTime}}
            </div>
            <div class="panel">
                <span class="title">点击事件：</span>{{bounce.clickType}}{{bounce.targetUrl}}
            </div>
            <div class="panel" v-if="bounce.showPopupPrompt">
                <span class="title">是否弹窗提示：</span>{{ bounce.isPopup === 1 ? '是' : '否' }}
            </div>
            <div class="panel" v-if="bounce.showPopupPrompt && bounce.isPopup === 1">
                <span class="title">弹窗内容：</span>{{ bounce.popupContent }}
            </div>

            <el-form :model="bounce">
                <select-school :schObj="bounce.schObj" :canUse="canUse"></select-school>
            </el-form>
        </div>
    </div>
    </div>
</template>

<script>
    import selectSchool from "../../common/selectSch.vue"

    export default {
        data() {
            return {
                canUse: false,
                bounce: {
                    schObj: {
                        openedSchools: [],
                        shieldedSchools: [],
                        applicableCampus: "1"
                    }
                }
            }
        },
        mounted() {

            //获取弹框详情
            let id = this.$util.getUrlParam("bounceId");
            this.getBounceDetail(id);

        },
        components: { selectSchool },
        methods: {
            getBounceDetail(id) {
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v1/operate/bounce/queryByBounceId?bounceId=' + id
                }).then((response) => {
                    if (response.data.error === 10000) {
                        let data = response.data.data;
                        data.startTime = data.startTime.replace(/-/g, "/");
                        data.endTime = data.endTime.replace(/-/g, "/");

                        data.schObj = {
                            openedSchools: [],
                            shieldedSchools: [],
                            applicableCampus: data.allUnidFlag ? data.allUnidFlag + "" : "0"
                        };
                        let schArray = data.bounceCampusList.map(item => { return { name: item.campusName, rootUnid: item.unid } });
                        data.allUnidFlag == 0 ? (data.schObj.shieldedSchools = schArray) : (data.schObj.openedSchools = schArray);

                        data.showPopupPrompt = [1, 5, 7].indexOf(data.clickType) > -1;
                        data.isPopup = data.isPopup != null ? data.isPopup * 1 : 0;
                        data.popupContent = data.popupContent || '';

                        switch (data.showStatus) {
                            case 1:
                                data.showStatus = '每天首次启动APP';
                                break;
                            case 2:
                                data.showStatus = '每次启动APP';
                                break;
                            case 3:
                                data.showStatus = '活动期间仅弹一次';
                                break;
                        };
                        switch (data.bounceType) {
                            case 0:
                                data.bounceType = '常规弹框';
                                break;
                            case 1:
                                data.bounceType = '不规则弹框';
                                break;
                        };

                        // 小程序地址拆分
                        let clickEvent = '';
                        if (data.clickType === 5) {
                            let wxAppId = this.$util.getUrlParam('id', data.targetUrl);
                            let wxAppUrl = this.$util.getUrlParam('path', data.targetUrl);
                            if (wxAppUrl) {
                                clickEvent = '原始id：' + wxAppId + '，小程序地址：' + wxAppUrl;
                            } else {
                                clickEvent = '原始id：' + wxAppId;
                            }
                        }

                        if (data.clickType === 7) {
                            let wxAppId = this.$util.getUrlParam('appId', data.targetUrl);
                            let wxAppUrl = this.$util.getUrlParam('page', data.targetUrl);
                            let query = this.$util.getUrlParam('query', data.targetUrl);
                            if (wxAppUrl) {
                                clickEvent = '原始id：' + wxAppId + '，小程序地址：' + wxAppUrl;
                            } else {
                                clickEvent = '原始id：' + wxAppId;
                            }
                            if (query) {
                                clickEvent = clickEvent + '，参数：' + query;
                            }
                        }

                        // 音频地址拆分
                        let musicUrl = '';
                        if (data.clickType === 6) {
                            let albumId = this.$util.getUrlParam('id', data.targetUrl),
                                nickName = this.$util.getUrlParam('nickName', data.targetUrl),
                                albumCount = this.$util.getUrlParam('count', data.targetUrl),
                                isPaid = this.$util.getUrlParam('isPaid', data.targetUrl) == 1 ? '是' : '否';

                            musicUrl = '专辑id：' + albumId + '，主播名称：' + nickName + '，单曲数：' + albumCount + '，是否付费：' + isPaid;
                        }

                        switch (data.clickType) {
                            case 0:
                                data.clickType = '不跳转';
                                break;
                            case 1:
                                data.clickType = '跳转至URL-';
                                break;
                            case 2:
                                data.clickType = '跳转至已有文章-';
                                break;
                            case 3:
                                data.clickType = '跳转至已有话题-';
                                break;
                            case 5:
                                data.clickType = '跳转至微信小程序-';
                                data.targetUrl = clickEvent;
                                break;
                            case 6:
                                data.clickType = '跳转至音频-';
                                data.targetUrl = musicUrl;
                                break;
                            case 7:
                                data.clickType = '跳转至支付宝小程序-';
                                data.targetUrl = clickEvent;
                                break;
                        };
                        this.bounce = data;
                    }
                })
            },
            goback() {
                history.back();
            }
        }
    }
</script>

<style>
    .bounceDetail {
        height: 100%;
    }

    .bounceDetail .title {
        display: inline-block;
        width: 140px;
        text-align: right;
    }

    .bounceDetail .detail {
        margin-left: 20px;
        overflow: hidden;
    }

    .bounceDetail .imgSpan {
        position: relative;
        top: -70px;
    }

    .bounceDetail .panel {
        height: 90px;
    }

    .bounceDetail img {
        display: inline-block;
        width: 150px;
        height: 80px;
    }

    .bounceDetail .contain {
        display: inline-block;
        padding: 15px 10px;
        width: 80%;
        height: 135px;
        box-sizing: border-box;
        border: solid 1px #999;
        overflow: scroll;
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// bounceDetail.vue?6281a913